
import Vue from 'vue'
import * as http from '@/api/http'
import { ProgressBar } from 'uiv'
import { StandardButton } from '@/components/buttons'

export default Vue.extend({
   name: 'TextboxFormGroup',
   props: {
      id: String,
      label: String,
      value: String,
      uploadUrl: { type: String, required: true },
   },
   data() {
      return {
         initialValue: '',
         innerValue: '',
         previewValue: '',
         version: Math.random(),
         dirty: false,

         file: null as File | null,
         uploading: false,
         uploaded: false,
         progress: 0,
         errorMessage: '' as string,
      }
   },
   computed: {
      hasFile(): boolean {
         return this.file !== null
      },
      canUpload(): boolean {
         return this.hasFile && !!this.uploadUrl
      },
      imageUrl(): string {
         if (this.previewValue) {
            return this.previewValue
         } else if (this.innerValue) {
            return `${this.innerValue}?v=${this.version}`
         } else {
            return ''
         }
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: string) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      reset() {
         this.file = null
         this.uploaded = false
         this.uploading = false
         this.progress = 0
         this.errorMessage = ''
      },
      resetUpload() {
         this.reset()
         const input = this.$refs.fileInput as HTMLInputElement
         input.value = ''
         input.type = 'text'
         input.type = 'file'
      },
      onFileSelect(event: any) {
         this.reset()
         if (event.target.files.length === 0) {
            return
         }
         this.file = event.target.files[0]
      },
      loadPreview() {
         const reader = new FileReader()

         reader.addEventListener(
            'load',
            () => {
               this.previewValue = reader.result as string
            },
            false
         )

         if (this.file) {
            if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
               reader.readAsDataURL(this.file)
            }
         }
      },
      onProgressEvent(progressEvent: ProgressEvent) {
         this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      },
      async upload() {
         if (this.file == null) {
            return
         }

         this.loadPreview()
         this.uploading = true
         const formData = new FormData()
         formData.append('files', this.file)

         try {
            const result = await http.upload(this.uploadUrl, formData, this.onProgressEvent)
            this.$emit('uploaded', this.file)
            this.uploaded = true
            this.reset()
            setTimeout(() => {
               this.version = Math.random()
               this.previewValue = ''
            }, 1000)
         } catch (err) {
            this.$emit('upload-failed', err)
         } finally {
            this.uploading = false
         }
      },
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit('input', this.innerValue)
      },
   },
   components: {
      StandardButton,
      ProgressBar,
   },
})
